import { h } from 'vue';

import { useGrid, useSubgrid } from '../composable';

import type { ISubgridProps } from '../composable';
import type { SetupContext } from 'vue';

export function CSSGrid(props: ISubgridProps, context: SetupContext) {
  const { prefix } = useGrid();
  const { suffix } = useSubgrid(props as ISubgridProps);

  return () =>
    h(
      props.tag,
      {
        class: {
          [`${prefix}--${suffix}`]: true,
          [`${prefix}--${suffix}--condensed`]: props.condensed,
          [`${prefix}--${suffix}--narrow`]: props.narrow,
          [`${prefix}--${suffix}--wide`]: props.subgrid || props.wide
        }
      },
      context.slots.default && context.slots.default()
    );
}

import './CSSGrid.scss';
